import React, { FC } from "react";
import { Paper as MuiPaper, PaperProps } from "@mui/material";
import useThemeCommon from "../../../commons/hooks/useThemeCommons";


const Paper: FC<PaperProps> = (props) => {
    return <MuiPaper style={{ ...props.style, background: useThemeCommon() }} {...props}/>
}

export default Paper;